<template>
    <div style="padding:1px;">
    <hd></hd>
    <div class="snatched">
      <h2 style="font-weight: bold;text-align: center;margin-bottom: 30px;">{{ term_title }}</h2>
      <div v-html="content"></div>
    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import mobilefooter from '../../components/mobilefooter'
import api from '../../services/api.js'

export default {
  name: 'Privacy',
  components: {
    hd: hd,
    mobilefooter: mobilefooter,
    ft: ft,
  },
  data () {
    return {
      mobiletype: false,
      loading: true,
      term_title:'',
      type:"0",
      content:'隐私协议'
    }
  },
  mounted () {
    switch(this.$route.query.type){
        case "2":
            this.type="2";
            this.term_title='客户须知';
            break;
        case "1":
            this.type="1";
            this.term_title='服务协议';
            break;
        default:
            this.type="0";
            this.term_title='隐私协议';
            break;
    }
    this.type = 
    this.getContent()
  },
  methods: {
    async getContent() {
        let res = {};
        switch(this.type){
            case "0":
                res = await api.getPrivacy(this);
                break;
            case "1":
                res = await api.getTerms(this);
                break;
            case "2":
                res = await api.getNoteCustomer(this)
                break;
        }
        if (res.body.status == 'ok') {
            this.loading = false
            this.content = res.body.result       
        }
    },
  },

}

</script>
<style scoped lang="scss">
  @font-face {
  font-family: "iconfont"; /* Project id 2668685 */
  /* Color fonts */
  src: 
       url('../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
       url('../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
       url('../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-icon-joyordervolumn:before {
  content: "\e61a";
}

.el-icon-joyordervolumn-mute:before {
  content: "\e63e";
}
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;

    .empty {
        overflow: hidden;
        clear: both;
        .empty-content {
            margin-top: 127px;

        }
    }

    .toggle {
        width: 210px;
        margin-right: 20px;
        &:last-child{
          margin-right:0px;
        }

        .el-select {
            width: 100%;
        }
        .el-autocomplete {
            width: 100%;
        }
    }
    .button {
        .refresh {
            width:98px;
            height:40px;
            background:rgba(243,243,249,1);
            border-radius:3px;
            border:1px solid rgba(222,226,236,1);
            padding: 5px 2px;
            cursor: pointer;

            .refreshIcon {
                display: inline-block;
                width:30px;
                height:30px;
                vertical-align: middle;
                transition: transform 0.5s;
                background: url('../../ico/refresh.png') ;
                background-size: cover;
            }
            @keyframes refresh {
                0% {  transform: rotate(0deg); }
                100% {  transform: rotate(360deg);  }
            }
            .rotate {
                animation: refresh 1s linear infinite;
            }
        }
    }
    .titleList {
        margin-top: 26px;
        padding: 17px 40px 17px 20px;

        .title {
            display: inline-block;
            height: 20px;
            line-height: 20px;
            color: #666666;
            font-size: 14px;
        }
    }
    .pool {
        img {
            // height: 100%;
            width: 45px;
            // height: 30px;
        }
        .poolTitle {
            display: inline-block;
            color: #333333;
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: top;

            .totlePrice {
                display: inline-block;
                font-size: 20px;
                margin-right: 5px;
                vertical-align: bottom;
            }
            .line {
                width:2px;
                height:16px;
                border:1px solid #999999;
                margin-right: 8px;
                margin-left: 8px;
            }
        }
        .goods {
            padding: 19px 40px 0 21px;
            overflow: hidden;

            .buyer {
                color: #888888;
                font-size: 14px;
            }

            .left-content {
                float: left;
                width: 60%;
                .goodsList {
                    margin-top: 15px;
                    float: left;
                    width: 100%;
                    .img-container {
                        float: left;
                        width: 120px;
                        height: 120px;
                        margin-right: 20px;
                        overflow: hidden;
                        a {
                        position: relative;
                        display: block;
                        width: 120px;
                        height: 120px;

                        .goodsNum{
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            display: inline-block;
                            height: 20px;
                            width: 20px;
                            border: 1px solid #979797;
                            border-radius: 50%;
                            text-align: center;
                            font-size: 10px;
                            line-height: 18px;
                            color: #333;
                            background: #fff;
                        }
                        }

                        img {
                            height: 120px;
                            width: 120px;
                            object-fit: contain;
                        }
                    }

                    .order-des {
                        float: left;
                        position: relative;
                        min-height: 120px;
                        width: calc(100% - 140px);

                        .order-price{
                        font-size: 18px;
                        line-height: 24px;
                        color: black;
                        margin: 0;
                        }

                        a.order-price {
                        color: #FF0000;
                        font-size: 18px;
                        }

                        del.order-price {
                        color: #9B9B9B;
                        font-size: 18px;
                        }
                        p {
                            word-break: break-all;

                            a {
                                color: #333333;
                                word-break: break-all;
                            }

                            span {
                            }
                        }
                    }
                }
            }
            .right-operation {
                float: right;

                .disabled {
                    width:177px;
                    height:50px;
                    background: #BABABB !important;
                    border: none;
                }
            }
        }
    }
    .redirct {
        font-size:24px;
        line-height:33px;
        padding-bottom: 70px;

        .completion {
            width:76px;
            height:76px;
            background-image: url('../../ico/blueSucccess@2x.png');
            background-position: 0 0;
            background-size: contain;
        }
        .fail {
            width:76px;
            height:76px;
            margin: 0 auto;
            border-radius: 50%;

            img {
                height: 33px;
                margin: 21px auto;
            }
        }
        p {
            color: #333333;
            font-size: 18px;
            margin-top: 45px;
        }
    }

} 
    @media screen and (min-width: 1026px){
      .snatched{
        .toggleList{
          display:flex;
          justify-content: space-between;
          .toggleGroup{
            display:flex;
            align-items: center;
          }
        }
      }
    }
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                display:block;
                padding-left: 0 !important;
                .toggleGroup{
                  display:block;
                  .warningWrapper{
                    float: left;
                    position: relative;
                    top: 10px;
                    margin-right: 20px;
                  }
                }
                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
.weeCtCoverBeforeDeal {
    position: relative;
    margin-top:15px;
    /*width: 380px;*/
    width: 310px;
    /*width: 430px;*/
    height: 135px;

    .coverMore{
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 120px;
        background-image: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.25), rgba(255,255,255,.75), rgba(255,255,255,.90), white);
        z-index: 1;
    }
    .ctCover{
        height: 120px;
        /*width: 3700px;*/
        display: flex;
        /*flex-wrap: nowrap;*/
        .cover {
            /*display: inline-block;*/
            width: 120px;
            height: 120px;
            margin-right: 10px;
            background-size: contain !important;
            &:last-of-type{
                margin-right: 25px;
            }
            cursor: pointer;
        }
        /*.gm-scroll-view{*/
        /*    display: flex;*/
        /*}*/
    }
}
.spec{
  display: flex;
  word-break: break-all;
  color: #888888;
  line-height: 24px;
  span {
    display: block;
  }
}
.volumn{
  transform: scale(1.5);
  cursor: pointer;
  margin-left:5px;
}
</style>
<style lang="scss">
    /*.weeCtCoverBeforeDeal{*/
    /*.gm-scroll-view{*/
    /*    width: 310px !important;*/
    /*    height: 95px !important;*/
    /*}*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/pages/privacy/privacy.vue